//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import _ from "js/underscore-mixins";

(function() {
  angular.module('curalate').service('SemanticTagsAliasHelper', [
    'SEARCH_FILTERS',
    'SearchFilterService',
    function(
      SEARCH_FILTERS,
      SearchFilterService,
    ) {
      /**
       * @param {Object[]} semanticTagFilters
       * @param {string} semanticTagFilters[].value - filter value
       * @param {string} semanticTagFilters[].tag - filter tag value
       */
      this.registerSemanticTagsFilterAliases = (semanticTagFilters) => {
        SearchFilterService.getObservableForFilterSet(SEARCH_FILTERS.COLLECTION_CONTENT_FILTERS).take(1).subscribe(() => {
          _(semanticTagFilters).each((semanticTagFilter) => {
            const value = semanticTagFilter.value || semanticTagFilter.tag;

            SearchFilterService.registerFilterOptionAlias(
              SEARCH_FILTERS.COLLECTION_CONTENT_FILTERS,
              'semanticTags',
              value,
              value.toLowerCase(),
            );
          });
        });
      };
    },
  ]);
})();
